// Projectfoto's per dienst — geoptimaliseerde WebP-bestanden op de CDN (zie src/assets/galerij-*.asset.json).

export const dienstGalerij: Record<string, string[]> = {
  "aanbouw": [
    "/__l5e/assets-v1/cb632589-2d73-4424-b479-ec9b135271b7/galerij-aanbouw-1.webp",
    "/__l5e/assets-v1/0a0dd2aa-cc7a-4518-adf8-b1cb3bf1a268/galerij-aanbouw-2.webp",
    "/__l5e/assets-v1/30b1eff9-3899-4f25-b3a8-36babdad8080/galerij-aanbouw-3.webp",
    "/__l5e/assets-v1/26d2005a-bd64-45d8-a0e8-15f1ccdb045d/galerij-aanbouw-4.webp",
    "/__l5e/assets-v1/e972d836-2179-459f-bde9-9b028c869485/galerij-aanbouw-5.webp",
    "/__l5e/assets-v1/5af4dc36-6dcc-43da-9b46-6355b51b2489/galerij-aanbouw-6.webp",
  ],
  "dakkapel": [
    "/__l5e/assets-v1/724342c1-1016-42e0-9ca2-e4bc72817550/galerij-dakkapel-1.webp",
    "/__l5e/assets-v1/9ff0f95c-2418-4202-baf5-670230cd6cd4/galerij-dakkapel-2.webp",
    "/__l5e/assets-v1/64eac833-e46e-49e5-bfa0-3fcb0f1bc803/galerij-dakkapel-3.webp",
    "/__l5e/assets-v1/493213ae-1755-4925-b39d-ccc22974fb69/galerij-dakkapel-4.webp",
    "/__l5e/assets-v1/a720efca-7548-4c3d-b6c5-fc72ae76a761/galerij-dakkapel-5.webp",
  ],
  "dakkapel-renovatie": [
    "/__l5e/assets-v1/0cc87457-df37-4447-89cc-c333b05d6368/galerij-dakkapel-renovatie-1.webp",
    "/__l5e/assets-v1/7c71e551-3756-468f-8575-c485e41435b5/galerij-dakkapel-renovatie-2.webp",
    "/__l5e/assets-v1/c6425c8b-308c-43ba-9237-a4c95ed5c722/galerij-dakkapel-renovatie-3.webp",
  ],
  "dakopbouw": [
    "/__l5e/assets-v1/d8a968c3-becd-453e-b79a-26fa19d17065/galerij-dakopbouw-1.webp",
    "/__l5e/assets-v1/241ec955-cfdc-44aa-91d3-65b6a6216936/galerij-dakopbouw-2.webp",
    "/__l5e/assets-v1/8ce44f89-c198-40e4-81a6-66dc24e74b5a/galerij-dakopbouw-3.webp",
    "/__l5e/assets-v1/4aa3ff55-9712-43d9-8f66-74cc68a5c2be/galerij-dakopbouw-4.webp",
    "/__l5e/assets-v1/14fd0abb-4362-445d-8f40-290e94d84eeb/galerij-dakopbouw-5.webp",
    "/__l5e/assets-v1/8e59f179-726c-4574-b9dc-0a194a8ca81e/galerij-dakopbouw-6.webp",
  ],
  "kozijnen": [
    "/__l5e/assets-v1/b42d716b-76e3-4f37-b922-363496ed9d90/galerij-kozijnen-1.webp",
    "/__l5e/assets-v1/c78b92a9-9424-4af7-a738-d93e8e9d4835/galerij-kozijnen-2.webp",
    "/__l5e/assets-v1/468a49a0-c54a-4e1f-9b8d-a3b598d206d9/galerij-kozijnen-3.webp",
    "/__l5e/assets-v1/6b282d17-492c-41e1-a49f-df0391c98524/galerij-kozijnen-4.webp",
    "/__l5e/assets-v1/d50cc603-eccd-4504-a87d-44eaf53938f1/galerij-kozijnen-5.webp",
    "/__l5e/assets-v1/f41807c9-c545-4bea-955c-c55ba7fa95c6/galerij-kozijnen-6.webp",
  ],
  "schuur": [
    "/__l5e/assets-v1/d3b1d209-bed7-4861-bbda-43bcdcffede7/galerij-overkapping-1.webp",
    "/__l5e/assets-v1/eff90d72-674e-41c4-8ffc-4e616e3f76c6/galerij-overkapping-2.webp",
    "/__l5e/assets-v1/d5526fda-0270-4e68-9074-8423c97439d6/galerij-overkapping-3.webp",
    "/__l5e/assets-v1/33969251-0285-4f8e-a3c0-eaf28ae48091/galerij-overkapping-4.webp",
    "/__l5e/assets-v1/9d622ca1-8328-46d2-871d-62881e67f777/galerij-overkapping-5.webp",
    "/__l5e/assets-v1/3fe8bc84-3b15-4004-a09a-8591a2ea495d/galerij-overkapping-6.webp",
  ],
  "renovatie": [
    "/__l5e/assets-v1/1cab8751-9abf-43ce-8922-678a8a347032/galerij-renovatie-1.webp",
    "/__l5e/assets-v1/6dfad404-ba77-4e91-afcf-f868f8506687/galerij-renovatie-2.webp",
    "/__l5e/assets-v1/32c97cb6-83c6-4196-b2c5-318b49e7ebba/galerij-renovatie-3.webp",
    "/__l5e/assets-v1/a756bb69-1f8a-4420-b9fa-c93c4dc9b535/galerij-renovatie-4.webp",
    "/__l5e/assets-v1/bffb07a1-914b-49bd-82a1-fc2c65e6ef52/galerij-renovatie-5.webp",
    "/__l5e/assets-v1/a37f045b-6145-4f0c-bf35-073cca0cc4b1/galerij-renovatie-6.webp",
  ],
  "specials": [
    "/__l5e/assets-v1/34a0e52b-ec75-487d-888d-e432dcacfb80/galerij-specials-1.webp",
    "/__l5e/assets-v1/dfc2da41-404c-48cd-ae59-2ae4c73cd767/galerij-specials-2.webp",
    "/__l5e/assets-v1/4d663932-3e24-4fa4-a4b3-0a9e70498d9b/galerij-specials-3.webp",
    "/__l5e/assets-v1/e6b51e5f-271a-4ea6-8e9c-e84c6a7efd2a/galerij-specials-4.webp",
    "/__l5e/assets-v1/0311492e-eb63-4640-a08f-b7935fcf5130/galerij-specials-5.webp",
    "/__l5e/assets-v1/cf207dbc-a921-47c4-827d-027ca206959c/galerij-specials-6.webp",
  ],
  "vlonder": [
    "/__l5e/assets-v1/d877881d-9556-4e19-a643-f3f0c73073b8/galerij-vlonder-1.webp",
    "/__l5e/assets-v1/75757191-33bc-49e1-8ebd-f390b346497d/galerij-vlonder-2.webp",
    "/__l5e/assets-v1/9fbb7201-4fdb-404d-83e0-174db50030d4/galerij-vlonder-3.webp",
    "/__l5e/assets-v1/8cbc9eeb-10e9-44d1-84f6-7444176b10c9/galerij-vlonder-4.webp",
    "/__l5e/assets-v1/1bb52e0a-06f3-4c7a-b64d-ace856087b26/galerij-vlonder-5.webp",
    "/__l5e/assets-v1/562e0d77-1af9-4e01-9913-3cff07e60cb6/galerij-vlonder-6.webp",
  ],
};
